<form [formGroup]="userInfoForm">
  <div class="user-info grid md:grid-cols-4 grid-cols-2 md:gap-4 gap-2 mb-4">
    <div class="civilite">
      <h2 class="mt-6 text-dark">{{ "userInfo.civility" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.civility }}</p>
    </div>
    <div class="prenom">
      <h2 class="mt-6 text-dark">{{ "userInfo.firstName" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.firstName }}</p>
    </div>
    <div class="nom">
      <h2 class="mt-6 text-dark">{{ "userInfo.lastName" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.lastName }}</p>
    </div>
    <div class="date-naissance">
      <h2 class="mt-6 text-dark">{{ "userInfo.birthDate" | translate }}</h2>
      <p class="font-bold text-darkest">
        {{ member?.birthDate | date: "dd/MM/yyyy" }}
      </p>
    </div>
    <div class="ville-naissance">
      <h2 class="mt-6 text-dark">{{ "userInfo.cityOfBirth" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.birthCity }}</p>
    </div>

    <div class="code-postale-naissance">
      <h2 class="mt-6 text-dark">{{ "userInfo.postalCodeOfBirth" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.birthZipCode }}</p>
    </div>

    <div class="pays-naissance">
      <h2 class="mt-6 text-dark">
        {{ "userInfo.countryOfBirth" | translate }}
      </h2>
      <p class="font-bold text-darkest">{{ member?.birthCountry }}</p>
    </div>

    <div class="nationalite">
      <h2 class="mt-6 text-dark">
        {{ "userInfo.nationality" | translate }}
      </h2>
      <p class="font-bold text-darkest">{{ member?.nationality }}</p>
    </div>

    <div class="email md:col-auto col-span-2">
      <h2 class="mt-6 text-dark">{{ "userInfo.email" | translate }}</h2>
      <p class="font-bold text-darkest">{{ member?.email }}</p>
    </div>
    <div class="mot-de-passe md:col-auto col-span-2">
      <h2 class="mt-6 text-dark">{{ "userInfo.password" | translate }}</h2>
      <div class="flex items-center space-x-2">
        <div>
          <p class="font-bold text-darkest">
            {{ "userInfo.passwordPlaceholder" | translate }}
          </p>
        </div>
        <div *ngIf="!isPartner()">
          <button
            class="text-red font-bold border p-2 border-red rounded-md"
            (click)="toggleChangePassword()">
            <i class="pi pi-pencil"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="telephone md:col-auto col-span-2">
      <h2 class="mt-6 text-dark">{{ "userInfo.phoneNumber" | translate }}</h2>
      <div *ngIf="!isEditMode; else editModePhone">
        <p class="font-bold text-darkest">
          {{
            member?.phoneNumber === undefined || member?.phoneNumber === null
              ? "-"
              : member?.phonePrefix + "" + member?.phoneNumber
          }}
        </p>
      </div>
      <ng-template #editModePhone>
        <div class="flex gap-2 mt-2">
          <p-dropdown
            [options]="phoneNumberPrefixes"
            (onChange)="onPhonePrefixChange()"
            formControlName="editedPhonePrefix"
            optionLabel="prefix"
            placeholder="Sélectionner"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            class="p-0 border border-light"></p-dropdown>
          <input
            type="text"
            [ngClass]="{
              'border-red ':
                userInfoForm.get('editedPhoneNumber')?.invalid && userInfoForm.get('editedPhoneNumber')?.touched,
            }"
            class="font-bold text-darkest border border-light p-2 rounded-md"
            formControlName="editedPhoneNumber" />
        </div>

        <div
          *ngIf="userInfoForm.get('editedPhoneNumber')?.invalid && userInfoForm.get('editedPhoneNumber')?.touched"
          class="text-red mt-2">
          {{ "userInfo.phoneNumberError" | translate }}
        </div>
        <div
          *ngIf="
            userInfoForm.get('editedPhoneNumber')?.errors?.['pattern'] && userInfoForm.get('editedPhoneNumber')?.touched
          "
          class="text-red mt-2">
          {{ "userInfo.phoneNumberError1" | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</form>
